import React, { useEffect, useRef } from "react";
import ToggleTheme from "../../features/main-page/components/get-conversation/ToggleTheme";
import { setMinimizeSidebar } from "../../store/one-query/chatsSlice";
import { useAppDispatch } from "../../store/hooks";
import { Box } from "@mui/material";
const PromoCodeSidebar = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setMinimizeSidebar(false));
  }, []);
  return (
    <Box className="promoCode-sidebar">
      <div className={`promo-code-word`}>
        <div className="text">
          <p className="titleFont mb-0 new-text">Promo codes</p>
        </div>
      </div>
    </Box>
  );
};
export default PromoCodeSidebar;
